import { Stack, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  color?: string;
  children?: React.ReactNode;
  subText?: string;
};

const SubjectBar = ({ sx, color, subText, children }: Props) => (
  <Stack
    direction="row"
    justifyContent={!subText ? 'flex-start' : 'space-between'}
    alignItems="end"
    sx={{
      width: '100%',
      mx: 'auto',
      my: 0,
      p: 0,
      borderBottom: `solid 2px ${color ? color : baseColors.red}`,
      ...sx
    }}
  >
    <Typography
      variant="h4"
      sx={{
        color: color ? color : baseColors.red
      }}
    >
      {children}
    </Typography>
    {!!subText && (
      <Typography
        variant="h6"
        sx={{
          color: color ? color : baseColors.red
        }}
      >
        {subText}
      </Typography>
    )}
  </Stack>
);

export default SubjectBar;
